import AxiosInstance from "services/api";

export const GoldCurrencyStatementService = {
  async getPaginate(query) {
    return await AxiosInstance.get("/private/gold-currency-statement", { params: query });
  },
  async getById(id) {
    return await AxiosInstance.get(`/private/gold-currency-statement/${id}`);
  },
  async create(payload) {
    return await AxiosInstance.post("/private/gold-currency-statement", payload);
  },
  async update(id, payload) {
    return await AxiosInstance.patch(`/private/gold-currency-statement/${id}`, payload);
  },
  async delete(id) {
    return await AxiosInstance.delete(`/private/gold-currency-statement/${id}`);
  },
};
